import {
  ASSET_GROUP_LIST, ASSET_GROUP_LIST_SUCCESS, ASSET_GROUP_LIST_FAILURE,
  ASSET_GROUP_DATA, ASSET_GROUP_DATA_SUCCESS, ASSET_GROUP_DATA_FAILURE,
  ASSET_GROUP_CREATE, ASSET_GROUP_CREATE_SUCCESS, ASSET_GROUP_CREATE_FAILURE,
  ASSET_GROUP_UPDATE, ASSET_GROUP_UPDATE_SUCCESS, ASSET_GROUP_UPDATE_FAILURE,
  ASSET_GROUP_DELETE, ASSET_GROUP_DELETE_SUCCESS, ASSET_GROUP_DELETE_FAILURE,
} from "./actionType";

export const assetGroupList = () => ({ type: ASSET_GROUP_LIST });
export const assetGroupListSuccess = (data) => ({ type: ASSET_GROUP_LIST_SUCCESS, payload: data });
export const assetGroupListFailure = (error) => ({ type: ASSET_GROUP_LIST_FAILURE, payload: error });

export const assetGroupData = (data) => ({ type: ASSET_GROUP_DATA, payload: data });
export const assetGroupDataSuccess = (data) => ({ type: ASSET_GROUP_DATA_SUCCESS, payload: data });
export const assetGroupDataFailure = (error) => ({ type: ASSET_GROUP_DATA_FAILURE, payload: error });

export const assetGroupCreate = (data) => ({ type: ASSET_GROUP_CREATE, payload: data });
export const assetGroupCreateSuccess = (data) => ({ type: ASSET_GROUP_CREATE_SUCCESS, payload: data });
export const assetGroupCreateFailure = (error) => ({ type: ASSET_GROUP_CREATE_FAILURE, payload: error });

export const assetGroupUpdate = (data) => ({ type: ASSET_GROUP_UPDATE, payload: data });
export const assetGroupUpdateSuccess = (data) => ({ type: ASSET_GROUP_UPDATE_SUCCESS, payload: data });
export const assetGroupUpdateFailure = (error) => ({ type: ASSET_GROUP_UPDATE_FAILURE, payload: error });

export const assetGroupDelete = (data) => ({ type: ASSET_GROUP_DELETE, payload: data });
export const assetGroupDeleteSuccess = (data) => ({ type: ASSET_GROUP_DELETE_SUCCESS, payload: data });
export const assetGroupDeleteFailure = (error) => ({ type: ASSET_GROUP_DELETE_FAILURE, payload: error });
